import coverageAreaService from "../../services/branch/coverageArea/coverageArea.js";
import branchService from "../../services/branch/BranchService.js";
import i18n from "../../i18n/index.js";

export default {
  data: () => ({
    branches: [],
    search: "",
    pagination: {},
    headers: [
      {
        text: i18n.t("headers.branch"),
        sortable: false,
        value: "name",
      },
    ],
  }),
  methods: {
    onRowClick(item) {
      this.$emit("onRowClick", item);
    },
    get() {
      this.loading = true;
      //const { page, rowsPerPage } = this.pagination;
      branchService.getBranchByCityPolicy(0, 10000, "").then((response) => {
        //console.log(response.data[0]);
        this.branches = response.data[0];
      });
    },
  },
  mounted() {
    this.get();
  },
  watch: {
    pagination: {
      handler() {
        this.get();
      },
      deep: true,
    },
  },
};
